

export default function ChiLinksComponent() {

    return (
        <div className="links">
            <div className="linkhead"><p style={{margin:'0px', marginBottom: '20px'}}>Please use the links below to find your ward and zone.</p></div>
            <div className="link1"> 

                <a 
                href="https://www.chicago.gov/city/en/depts/mayor/iframe/lookup_ward_and_alderman.html">
                    Find Your Ward
                </a>
                 
            </div>
            <div className="link2">
                <a
                href="https://www.chicago.gov/city/en/depts/streets/provdrs/streets_san/svcs/street_sweeping2026.html">
                    Street Sweeping Zone Map
                </a>
            </div>

        </div>


    )



}